export default __webpack_public_path__ + "static/traefik-enterprise-logo--white-c6600967c2c48adbc29636d8e73ea646.svg";